import { useEffect, useState } from "react";
import { API } from "./api";
import { Card, CardContent, Typography, Grid } from "@mui/material";
import Dashboard from "./Dashboard";

export default function RelianceMatrix() {
  const [apps, setApps] = useState([]);
  const [selectedApp, setSelectedApp] = useState(null);
  const [selectedEnv, setSelectedEnv] = useState(null);

  useEffect(() => {
    API.get("/apps").then(res => {
      const data = res.data.data || res.data || [];

      // ✅ FILTER ONLY RELIANCE CLIENT
      const filtered = data.filter(
  a => (a.client || "").trim().toLowerCase() === "reliance_matrix"
);

      setApps(filtered);
    });
  }, []);

  // App cards
  if (!selectedApp) {
    const uniqueApps = [...new Set(apps.map(a => a.app_name))];

    return (
      <Grid container spacing={3}>
        {uniqueApps.map(app => (
          <Grid item xs={2} key={app}>
            <Card onClick={() => setSelectedApp(app)}
              style={{ cursor: "pointer", background: "#f59e0b", color: "white" }}>
              <CardContent>
                <Typography>{app}</Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    );
  }

  // Env cards
  if (!selectedEnv) {
    const envs = [...new Set(
      apps
        .filter(a => a.app_name === selectedApp)
        .map(a => a.environment)
    )];

    return (
      <Grid container spacing={3}>
        {envs.map(env => (
          <Grid item xs={2} key={env}>
            <Card onClick={() => setSelectedEnv(env)}
              style={{ cursor: "pointer", background: "#22c55e", color: "white" }}>
              <CardContent>
                <Typography>{env}</Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    );
  }

  // Table
  return (
    <Dashboard
      filterApp={selectedApp}
      filterEnv={selectedEnv}
      filterClient="Reliance_Matrix"
    />
  );
}
